import axios from 'axios';
import {getField, updateField} from 'vuex-map-fields';
// import { downloadFile } from "@/helpers/helpers";

const getDefaultState = () => {
    return {
        config: {daysInStock: null, safetyStock: null, suggestedPriceRules: []},
    }
}

export const state = getDefaultState();

export const getters = {
    getField
}

export const actions = {
    async fetchConfig({commit}) {
        const response = await axios.get(`/fastmarket/admin/config/user`);
        commit('SET_CONFIG', response.data)
    },
    /*eslint no-unused-vars: ["error", { "args": "none" }]*/
    async createOrUpdate({commit, state}) {
        await axios.post('/fastmarket/admin/config/update', {
            suggestedPriceRules: state.config.suggestedPriceRules,
            daysInStock: state.config.daysInStock,
            safetyStock: state.config.safetyStock,
            maxDaysReturn: state.config.maxDaysReturn,
            referredCommissionPercent: state.config.referredCommissionPercent,
            paymentDirectDays: state.config.paymentDirectDays
        });
    }

}

export const mutations = {
    updateField,
    SET_CONFIG(state, result) {
        state.config = result
    }
}